import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="26" height="26" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M11.7 2.71l6.39 10.23a2 2 0 01-1.7 3.06H3.61a2 2 0 01-1.7-3.06l6.4-10.23a2 2 0 013.39 0z" fill="#FEA509" /><g transform="translate(9 5)" fill="#FFF"><path d="M1 0a1 1 0 011 1v4a1 1 0 11-2 0V1a1 1 0 011-1z" /><circle cx="1" cy="8" r="1" /></g></g></svg>);